import { api } from './api';
import { setCookie } from '../helpers/cookieHelpers';

export const guestApi = api.injectEndpoints({
  reducerPath: 'guestApi',
  endpoints: (builder) => ({
    getGuestSession: builder.mutation({
      query: () => ({
        url: 'guest/session',
        method: 'post',
      }),
      transformResponse: (response) => {
        const token = response?.guest_session_token;
        const expireIn = response?.guest_session_token_expire_in || 3600;
        
        // Set cookie if token exists
        if (token) {
          setCookie('guest_session_token', token, {
            expiryIn: expireIn,
          });
        }
        
        return {
          guest_session_token: token,
          guest_session_token_expire_in: expireIn,
        };
      },
    }),
  }),
});

export const { useGetGuestSessionMutation } = guestApi;
